import { useState } from "react";
import { Database, Gauge } from "@phosphor-icons/react";
import SubmissionsTab from "./SubmissionsTab";
import FormManagementTab from "./FormManagementTab";
import JobsTab from "./JobsTab";
import SmsSettingsTab from "./SmsSettingsTab";

export function ViewPill({ view, onChange }) {
  const opt = (k, label, Icon) => (
    <button type="button" onClick={() => onChange(k)} aria-pressed={view === k}
      className={`inline-flex items-center gap-1.5 rounded-full px-3.5 h-8 text-xs font-semibold transition-colors duration-150 ${view === k ? "bg-[#327de3] text-[#ffffff] shadow-sm" : "text-[#4a8be6] hover:bg-[#327de3]/10"}`}
      data-testid={`ts-view-${k}`}>
      <Icon size={13} weight="bold" />{label}
    </button>
  );
  return (
    <div className="inline-flex items-center rounded-full border border-[#327de3]/30 bg-[#327de3]/10 p-0.5" data-testid="ts-view-pill">
      {opt("dashboard", "Dashboard", Gauge)}{opt("raw", "Raw Data & Form Settings", Database)}
    </div>
  );
}

export default function RawDataPanel({ access }) {
  const tabs = [
    access.timesheet_raw_view && ["submissions", "Submissions"],
    access.timesheet_form_manage && ["form", "Form Management"],
    access.timesheet_jobs_manage && ["jobs", "Jobs / Properties"],
    access.timesheet_sms_manage && ["sms", "SMS Settings"],
  ].filter(Boolean);
  const [tab, setTab] = useState(tabs[0]?.[0]);
  if (!tabs.length) {
    return <div className="rounded-xl border border-slate-200 bg-white p-8 text-center text-sm text-slate-500" data-testid="raw-no-tabs">Ask a super admin to grant Raw Data permissions in Admin → User Management.</div>;
  }
  return (
    <div className="ts-xfade space-y-4" data-testid="raw-data-panel">
      <div className="flex gap-1 overflow-x-auto border-b border-slate-200">
        {tabs.map(([k, label]) => (
          <button key={k} type="button" onClick={() => setTab(k)}
            className={`whitespace-nowrap px-4 h-10 text-sm font-semibold border-b-2 -mb-px transition-colors ${tab === k ? "border-[#327de3] text-[#1f64c2]" : "border-transparent text-slate-500 hover:text-slate-800"}`}
            data-testid={`raw-tab-${k}`}>{label}</button>
        ))}
      </div>
      <div key={tab} className="ts-xfade">
        {tab === "submissions" && <SubmissionsTab access={access} />}
        {tab === "form" && <FormManagementTab />}
        {tab === "jobs" && <JobsTab />}
        {tab === "sms" && <SmsSettingsTab />}
      </div>
    </div>
  );
}
